<script setup>
import logoText from '~/assets/icon_logo_text.svg'
import logoFull from '~/assets/icon_logo_full.svg'
import AppToast from '../AppToast.vue'
import { useRoute } from 'vue-router'
import HeaderProfileDropdown from '../HeaderProfileDropdown.vue'
import { useAuthStore, useAppStore } from '../../stores';
import { computed } from 'vue'
const authStore = useAuthStore();
const appStore = useAppStore();

const route = useRoute()

const isCurrentPath = (path) => {
    return route.path === path
}

const headerBorder = computed(() => {
    return appStore.showAccountFeatures ? 'border-b border-gray-200' : ''
})

</script>
<template>
    <div :class="`z-20 w-screen bg-white ${headerBorder}`">
        <AppToast />
        <div v-if="appStore.showAccountFeatures" class="flex flex-row items-center mx-auto py-4 px-4">
            <router-link to="/" class="basis-2/4 ">
                <img class="w-18 h-18 mr-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 20 20" :src="logoText" />
            </router-link>
            <div v-if="appStore.showAccountFeatures" class="basis-2/4 justify-self-end">
                <Suspense>
                    <template #fallback>
                        Loading
                    </template>
                    <HeaderProfileDropdown />
                </Suspense>
            </div>
        </div>
        <div v-else class="mx-auto p-4 flex flex-row justify-center"> 
            <img class="w-18 h-18" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"
                :src="logoFull" />
        </div>
        <div class="h-12 bg-accent flex flex-row justify-start items-center overflow-y-auto whitespace-nowrap"
            v-if="appStore.showHeaderChildPicker && authStore.sortedChildren.length > 0">
            <div v-for="child in authStore.sortedChildren" class="text-white text-xl p-2"
                @click="authStore.currentChildId = child.id"
                :class="child.id == authStore.currentChildId ? 'border-b-4 border-white' : ''">
                {{ child.first_name }}
            </div>
        </div>
    </div>
</template>